import { createSlice } from "@reduxjs/toolkit"


const AdminInitialState:any = {
    placements:[],
    events:[]
}

const AdminSlice = createSlice({
    name:"Admin",
    initialState:AdminInitialState,
    reducers:{
        setPlacements:(state,action) => {
            state.placements = action.payload
        },
        setEvents:(state,action) => {
            state.events = action.payload
        },
    }

})
export default AdminSlice